import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import {
    Document,
    Packer,
    Paragraph,
    TextRun,
    HeadingLevel,
    AlignmentType,
    ImageRun,
    Table,
    TableRow,
    TableCell,
    WidthType,
    BorderStyle,
} from "docx";
import logoUrl from "../../../assets/images/123.jpg";


const NamePublicationAdminReport = () => {
    const [publicationData, setPublicationData] = useState([]);
    const tableRef = useRef(null);

    useEffect(() => {
        const fetchPublicationData = async () => {
            try {
                // Retrieve token from localStorage or sessionStorage
                const authToken = localStorage.getItem("authToken"); // or sessionStorage.getItem('token')

                const response = await fetch(`${API_BASE_URL}/NamePublication/GetPublicationRecords`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${authToken}`, // Attach token in the request

                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                let data = await response.json();

                // Add SrNo property to each record
                data = data.map((record, index) => ({
                    ...record,
                    SrNo: index + 1, // Auto-incrementing SrNo
                    newName: `${record.newFirstName || ""} ${record.newMiddleName || ""} ${record.newLastName || ""}`.trim() || record.name || "-"
                }));

                setPublicationData(data); // Update state with modified data
            } catch (error) {
                console.error('Failed to fetch publication records:', error);
            }
        };

        fetchPublicationData();
    }, []);

    console.log(publicationData);

    // Function to update status
    const handleStatusChange = async (registrationNo, newStatus) => {
        const comment = prompt("Enter comment for this status change:");
        if (!comment) return; // Optional: require comment

        try {
            const authToken = localStorage.getItem("authToken");

            const response = await fetch(`${API_BASE_URL}/NamePublication/updateStatus/${registrationNo}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({ status: newStatus, comment }),
            });

            if (!response.ok) throw new Error("Failed to update status");

            // Update UI state
            setPublicationData(prev =>
                prev.map(row =>
                    row.registrationNo === registrationNo
                        ? { ...row, status: newStatus, comment }
                        : row
                )
            );

        } catch (error) {
            console.error("Error updating status:", error);
        }
    };
    const createTextRun = (text, options = {}) => {
        return new TextRun({
            text,
            bold: options.bold || false,
            italics: options.italics || false,
            underline: options.underline ? {} : undefined,
            size: options.size || 24,
            font: options.font || "Times New Roman",
            allCaps: options.allCaps || false,
        });
    };

    const createParagraph = (text, options = {}) => {
        const children = Array.isArray(text)
            ? text.map(run => createTextRun(run.text, run.options || {}))
            : [createTextRun(text, options)];

        return new Paragraph({
            children,
            heading: options.heading,
            alignment: options.alignment || AlignmentType.LEFT,
            spacing: {
                before: options.before || 80,
                after: options.after || 80,
                line: options.line || 360,
            },
            indent: options.indent,
        });
    };

    const fetchImageData = async (url) => {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch image: ${response.status}`);
        }
        const buffer = await response.arrayBuffer();
        return new Uint8Array(buffer);
    };

    const downloadDocument = async (documentType, registrationNo) => {
        console.log("Starting download for:", documentType, registrationNo);

        // Ensure registrationNo is compared as string
        const record = publicationData.find(item => String(item.registrationNo) === String(registrationNo));
        if (!record) {
            console.error("Record not found for document download:", registrationNo);
            console.log("Available records:", publicationData.map(r => r.registrationNo));
            alert("Record not found. Please refresh the page and try again.");
            return;
        }

        console.log("Found record:", record);

        const oldFullName = `${record.oldFirstName || ""} ${record.oldMiddleName || ""} ${record.oldLastName || ""}`.trim() || "-";
        const newFullName = `${record.newFirstName || ""} ${record.newMiddleName || ""} ${record.newLastName || ""}`.trim() || record.name || "-";
        const fatherOrHusbandName = record.fatherName || record.husbandName || "-";
        const addressText = record.address ? `${record.address}${record.district ? ", " + record.district : ""}${record.pinCode ? ", " + record.pinCode : ""}` : "-";
        const placeText = record.district || "Mumbai";
        const applicantName = record.name || newFullName;
        const fullAddress = record.address ? `${record.address}, ${record.district || ""}, ${record.pinCode || ""}` : "-";

        let fileName = "";
        let children = [];

        let logoBuffer = null;
        try {
            logoBuffer = await fetchImageData(logoUrl);
        } catch (error) {
            console.warn("Logo image could not be loaded, continuing without logo:", error);
        }

        if (documentType === "gazette") {
            fileName = `Gazette_Form_${registrationNo}.docx`;

            const logoParagraph = logoBuffer
                ? new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                          new ImageRun({
                              data: logoBuffer,
                              transformation: { width: 90, height: 70 },
                          }),
                      ],
                  })
                : null;

            children = [
                ...(logoParagraph ? [logoParagraph] : []),
                createParagraph("GOVERNMENT OF MAHARASHTRA", { alignment: AlignmentType.CENTER, bold: true, size: 28, allCaps: true, before: 0, after: 0 }),
                createParagraph("DIRECTORATE OF GOVERNMENT PRINTING, STATIONERY AND PUBLICATION", { alignment: AlignmentType.CENTER, bold: true, size: 18, allCaps: true, before: 0, after: 0 }),
                createParagraph("FORM FOR CHANGE OF NAME NOTICE", { alignment: AlignmentType.CENTER, bold: true, size: 18, allCaps: true, before: 0, after: 5 }),
                createParagraph("N.B.", { size: 22, before: 0, after: 0 }),
                createParagraph("( Instructions may be followed carefully before filling up this form. Only one word should be written in each space printed bellow. Please fill up this form in English version and BLOCK LETTERS only )", { size: 22, before: 0, after: 10, line: 280 }),
                createParagraph("It is hereby notified that the undersigned has changed his/her name from", { before: 0, after: 5, bold: true, }),
                new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    rows: [
                        new TableRow({
                            children: [
                                new TableCell({
                                    children: [createParagraph("OLD NAME", { bold: true, allCaps: true })],
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        bottom: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        left: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        right: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                    },
                                    width: { size: 25, type: WidthType.PERCENTAGE },
                                }),
                                new TableCell({
                                    children: [createParagraph(record.oldFirstName || "-", { size: 18 })],
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        bottom: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        left: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        right: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                    },
                                }),
                                new TableCell({
                                    children: [createParagraph(record.oldMiddleName || "-", { size: 18 })],
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        bottom: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        left: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        right: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                    },
                                }),
                                new TableCell({
                                    children: [createParagraph(record.oldLastName || "-", { size: 18 })],
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        bottom: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        left: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        right: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                    },
                                }),
                            ],
                        }),
                    ],
                }),
                createParagraph("", { before: 5, after: 5 }),
                new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    rows: [
                        new TableRow({
                            children: [
                                new TableCell({
                                    children: [createParagraph("To", { size: 20, allCaps: false })],
                                    borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                    },
                                    width: { size: 25, type: WidthType.PERCENTAGE },
                                }),
                                new TableCell({
                                    children: [createParagraph("Name", { size: 20, allCaps: false })],
                                    borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                    },
                                    width: { size: 25, type: WidthType.PERCENTAGE },
                                }),
                                new TableCell({
                                    children: [createParagraph("Father’s/Husband’s Name", { size: 20, allCaps: false })],
                                    borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                    },
                                    width: { size: 25, type: WidthType.PERCENTAGE },
                                }),
                                new TableCell({
                                    children: [createParagraph("Surname", { size: 20, allCaps: false })],
                                    borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                    },
                                    width: { size: 20, type: WidthType.PERCENTAGE },
                                }),
                            ],
                        }),
                        new TableRow({
                            children: [
                                new TableCell({
                                    children: [createParagraph("New Name", { size: 18, bold: true, allCaps: true })],
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        bottom: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        left: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        right: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                    },
                                }),
                                new TableCell({
                                    children: [createParagraph(record.newFirstName || "-", { size: 18 })],
                                    borders: {  
                                        top: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        bottom: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        left: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        right: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                    },
                                }),
                                new TableCell({
                                    children: [createParagraph(record.newMiddleName || "-", { size: 18 })],
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        bottom: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        left: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        right: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                    },
                                }),
                                new TableCell({
                                    children: [createParagraph(record.newLastName || "-", { size: 18 })],
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        bottom: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        left: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                        right: { style: BorderStyle.SINGLE, size: 3, color: "000000" },
                                    },
                                }),
                            ],
                        }),
                    ],
                }),
                createParagraph("Note :- Government accepts no responsibility as to the authenticity of the contents of the notice. Since they are based entirely on the application of the concerned persons without verification of documents.", {  size: 22, before: 0, after: 0, line: 240, weight: 500 }),
                createParagraph("", { before: 40, after: 10 }),
                new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    borders: {
                        top: { style: BorderStyle.NONE },
                        bottom: { style: BorderStyle.NONE },
                        left: { style: BorderStyle.NONE },
                        right: { style: BorderStyle.NONE },
                        insideHorizontal: { style: BorderStyle.NONE },
                        insideVertical: { style: BorderStyle.NONE },
                    },
                    rows: [
                        new TableRow({
                            children: [
                                new TableCell({
                                    children: [createParagraph("SIGNATURE OF THE GUARDIAN", { size: 22, before: 20, after: 40 })],
                                    borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                    },
                                    width: { size: 50, type: WidthType.PERCENTAGE },
                                }),
                                new TableCell({
                                    children: [createParagraph("Signature in Old name/Thumb Impression with name and date\n(In case of Minor)\n(write down the name of the person in the above Space who has signed above)", { alignment: AlignmentType.RIGHT, size: 22, before: 10, after: 20, line: 280 })],
                                    borders: {
                                        top: { style: BorderStyle.NONE },
                                        bottom: { style: BorderStyle.NONE },
                                        left: { style: BorderStyle.NONE },
                                        right: { style: BorderStyle.NONE },
                                    },
                                    width: { size: 50, type: WidthType.PERCENTAGE },
                                }),
                            ],
                        }),
                    ],
                }),
                //createParagraph(`Date : ${record.startDate || "-"}`, { size: 16, before: 20, after: 20 }),
                createParagraph("To,", { bold: true, size: 22, before: 20, after: 20, line: 280 }),
                createParagraph("The Director,", { size: 22, before: 20, after: 5, line: 280 }),
                createParagraph("Government Printing, Stationery and Publications, Maharashtra, Mumbai – 400 004.", { indent: { left: 320 }, size: 22, before: 0, after: 0, line: 280 }),
                createParagraph("Kindly publish the above notice in the next issue of the Maharashtra Government Gazette, Part II.", { size: 22, before: 0, after: 0, line: 280 }),
                createParagraph("", { before: 40, after: 10 }),
                createParagraph([
                    { text: "Reason for Change of Name: ", options: { size: 22 } },
                    { text: (record.reason || "-") + "\u00A0".repeat(30), options: { size: 22, underline: true } },
                ], { size: 22, before: 10, after: 20 }),
                createParagraph("", { before: 40, after: 10 }),
                createParagraph("SIGNATURE IN NEW NAME/THUMB IMPRESSION WITH NAME AND DATE", { alignment: AlignmentType.RIGHT, size: 16, before: 30, after: 20 }),
                createParagraph("FOR CORRESPONDING ADDRESS:", { bold: true, allCaps: true, size: 20, before: 20, after: 10 }),
                createParagraph([
                    { text: `New Name : `, options: { allCaps: true, size: 18 } },
                    { text: newFullName, options: { allCaps: true, size: 18 } },
                ], { size: 10, before: 5, after: 5 }),
                createParagraph([
                    { text: `Address : `, options: { allCaps: true, size: 18 } },
                    { text: fullAddress, options: { allCaps: true, size: 18 } },
                ], { size: 10, before: 5, after: 5 }),
                createParagraph([
                    { text: `PIN Code : `, options: { allCaps: true, size: 18 } },
                    { text: record.pinCode || "-", options: { allCaps: true, size: 18 } },
                ], { size: 10, before: 5, after: 5 }),
                createParagraph([
                    { text: `TEL. No. : `, options: { allCaps: true, size: 18 } },
                    { text: record.telephone || "-", options: { allCaps: true, size: 18 } },
                ], { size: 10, before: 5, after: 5 }),
                createParagraph([
                    { text: `Mobile No. : `, options: { allCaps: true, size: 18 } },
                    { text: record.mobileNo || "-", options: { allCaps: true, size: 18 } },
                ], { size: 10, before: 5, after: 5 }),
            ];
        } else if (documentType === "declaration-self") {
            fileName = `Declaration_Self_${registrationNo}.docx`;
            children = [
                createParagraph("AFFIDAVIT", { alignment: AlignmentType.CENTER, bold: true, size: 32, allCaps: true }),
                createParagraph(""),
                createParagraph([
                    { text: `I, ` },
                    { text: applicantName, options: { bold: true } },
                    { text: `, an adult, Indian inhabitant, residing at ` },
                    { text: fullAddress, options: { bold: true } },
                    { text: `, do hereby state and declare on solemnly affirmation as under:` },
                ], { line: 360 }),
                createParagraph(""),
                createParagraph([
                    { text: `I state and declare that previously my full name was ` },
                    { text: oldFullName, options: { bold: true } },
                    { text: ` and after I have changed my name to ` },
                    { text: newFullName, options: { bold: true } },
                    { text: `.` },
                ], { line: 360 }),
                createParagraph(""),
                createParagraph([
                    { text: `I state and declare that ` },
                    { text: oldFullName, options: { bold: true } },
                    { text: ` and ` },
                    { text: newFullName, options: { bold: true } },
                    { text: ` are one and same person i.e. myself.` },
                ], { line: 360 }),
                createParagraph(""),
                createParagraph("I am making this affidavit in order to produce the same before the concerned Govt. Gazette authorities to show above said facts.", { italics: true }),
                createParagraph(""),
                createParagraph("Whatever state hereinabove is true and correct to the best of my knowledge and belief. If the contents of this Affidavit proved to be false then we shall be liable for u./s. 236,237 of Bharatiya Nyaya Sanhita.", { line: 360 }),
                createParagraph(""),
                createParagraph([
                    { text: `PLACE : `, options: { bold: true, allCaps: true } },
                    { text: placeText, options: { bold: true } },
                ]),
                createParagraph([
                    { text: `DATE : `, options: { bold: true, allCaps: true } },
                    { text: record.startDate || "-", options: { bold: true } },
                ]),
                createParagraph(""),
                createParagraph([
                    { text: `(` },
                    { text: newFullName, options: { bold: true } },
                    { text: `)` },
                ], { alignment: AlignmentType.CENTER, underline: true, indent: { left: 6000 } }),
            ];
        } else if (documentType === "declaration-son-daughter") {
            fileName = `Declaration_Son_Daughter_${registrationNo}.docx`;
            children = [
                createParagraph("DECLARATION", { alignment: AlignmentType.CENTER, bold: true, size: 32, allCaps: true }),
                createParagraph(""),
                createParagraph([
                    { text: `I, ` },
                    { text: applicantName, options: { bold: true } },
                    { text: fatherOrHusbandName !== "-" ? ` w/o or d/o ${fatherOrHusbandName}` : "" },
                    { text: `, Indian inhabitant, residing at ` },
                    { text: fullAddress, options: { bold: true } },
                    { text: `, do hereby state and declare on solemnly affirmation as under:` },
                ], { line: 360 }),
                createParagraph(""),
                createParagraph([
                    { text: `I state and declare that previously my daughter full name was ` },
                    { text: oldFullName, options: { bold: true } },
                    { text: ` and after I have changed her name to ` },
                    { text: newFullName, options: { bold: true } },
                    { text: `.` },
                ], { line: 360 }),
                createParagraph(""),
                createParagraph([
                    { text: `I state and declare that ` },
                    { text: oldFullName, options: { bold: true } },
                    { text: ` and ` },
                    { text: newFullName, options: { bold: true } },
                    { text: ` are one and same person i.e. herself.` },
                ], { line: 360 }),
                createParagraph(""),
                createParagraph("I am making this affidavit in order to produce the same before the concerned Govt. Gazette authorities to show above said facts.", { italics: true }),
                createParagraph(""),
               
                createParagraph([
                    { text: `PLACE : `, options: { bold: true, allCaps: true } },
                    { text: placeText, options: { bold: true } },
                ]),
                createParagraph([
                    { text: `DATE : `, options: { bold: true, allCaps: true } },
                    { text: record.startDate || "-", options: { bold: true } },
                ]),
                createParagraph(""),
                createParagraph([
                    { text: `(` },
                    { text: newFullName, options: { bold: true } },
                    { text: `)` },
                ], { alignment: AlignmentType.CENTER, underline: true, indent: { left: 6000 } }),
            ];
        }

        const doc = new Document({
            sections: [
                {
                    properties: {},
                    children,
                },
            ],
        });

        console.log("Document created, generating blob...");

        try {
            const blob = await Packer.toBlob(doc);
            console.log("Blob generated, size:", blob.size);

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            console.log("Download initiated for:", fileName);
        } catch (error) {
            console.error("Failed to generate Word document:", error);
            alert(`Failed to generate document. Error: ${error.message}`);
        }
    };


    useEffect(() => {
        if (tableRef.current && publicationData.length > 0) {
            const table = $(tableRef.current).DataTable({
                destroy: true, // Destroy existing table instance
                data: publicationData,
                drawCallback: function() {
                    // Bind events after table draw
                    $('#productsTable tbody').off('click', '.gazette-btn').on('click', '.gazette-btn', function () {
                        const registrationNo = $(this).data("id");
                        console.log("Gazette button clicked for:", registrationNo);
                        downloadDocument("gazette", registrationNo);
                    });

                    // Handle Declaration Self download
                    $('#productsTable tbody').off('click', '.declaration-self-btn').on('click', '.declaration-self-btn', function () {
                        const registrationNo = $(this).data("id");
                        console.log("Declaration Self button clicked for:", registrationNo);
                        downloadDocument("declaration-self", registrationNo);
                    });

                    // Handle Declaration Son Daughter download
                    $('#productsTable tbody').off('click', '.declaration-son-daughter-btn').on('click', '.declaration-son-daughter-btn', function () {
                        const registrationNo = $(this).data("id");
                        console.log("Declaration Son Daughter button clicked for:", registrationNo);
                        downloadDocument("declaration-son-daughter", registrationNo);
                    });

                    // Handle status change
                    $(tableRef.current).off("change", ".status-dropdown").on("change", ".status-dropdown", function () {
                        const registrationNo = $(this).attr("data-id");
                        const newStatus = $(this).val();
                        const comment = ""; // Or however you get it
                        handleStatusChange(registrationNo, newStatus, comment);
                    });

                    // Handle download button click
                    $('#productsTable tbody').off('click', '.download-btn').on('click', '.download-btn', function () {
                        const registrationNo = $(this).data("id");
                        downloadPDF(registrationNo, "form");
                    });

                    $('#productsTable tbody').off('click', '.download-doc-btn').on('click', '.download-doc-btn', function () {
                        const registrationNo = $(this).data("id");
                        downloadPDF(registrationNo, "document");
                    });

                    // Handle Upload Button Click
                    $("#productsTable tbody").off("click", ".upload-btn").on("click", ".upload-btn", function () {
                        const registrationNo = $(this).data("id"); // Ensure this is a string
                        $(`.file-input[data-id='${registrationNo}']`).trigger("click");
                    });

                    // Handle File Selection
                    $("#productsTable tbody").off("change", ".file-input").on("change", ".file-input", function () {
                        const registrationNo = $(this).data("id"); // Ensure this is a string
                        const file = this.files[0];
                        if (file) {
                            uploadFile(registrationNo, file);
                        }
                    });
                },
                columns: [
                    { data: 'SrNo', title: 'Sr No' }, // Dynamically added field
                    { data: 'startDate', title: 'Date' }, // Matches 'startDate'
                    { data: 'name', title: 'Applicant Name' }, // Matches 'name'
                    { data: 'newName', title: 'New Name' }, // New Name
                    { data: 'registrationNo', title: 'Registration No' }, // Matches 'registrationNo'
                    {
                        data: 'status',
                        title: 'Status',
                        render: function (data, type, row) {
                            return `
                      <select class="form-control status-dropdown" data-id="${row.registrationNo}">
                        <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                        <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                        <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                        <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                        </select>
                    `;
                        }
                    },
                    { data: 'comment', title: 'Comment' },
                    {
                        data: null,
                        title: "Submitted Form",
                        render: function (data, type, row) {
                            return `<button class='btn btn-sm btn-primary download-btn' data-id='${row.registrationNo}'>Download PDF</button>`;
                        },
                    },
                    {
                        data: null,
                        title: "Document",
                        render: function (data, type, row) {
                            return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}'>Download</button>`;
                        },
                    },
                    {
                        data: null,
                        title: "Upload Receipt",
                        render: (data, type, row) => `
                     <input type='file' class='file-input' data-id='${row.registrationNo}' style='display:none;' accept='.pdf,.jpg,.png,.docx'/>
                     <button class='btn btn-sm btn-warning upload-btn' data-id='${row.registrationNo}'>Upload</button>
                     
                    `,
                    },
                    {
                        data: null,
                        title: "Gazette Form",
                        render: function (data, type, row) {
                            return `<button class='btn btn-sm btn-info gazette-btn' data-id='${row.registrationNo}'>Download</button>`;
                        },
                    },
                    {
                        data: null,
                        title: "DECLARATION - SELF",
                        render: function (data, type, row) {
                            return `<button class='btn btn-sm btn-info declaration-self-btn' data-id='${row.registrationNo}'>Download</button>`;
                        },
                    },
                    {
                        data: null,
                        title: "DECLARATION - SON & DAUGHTER",
                        render: function (data, type, row) {
                            return `<button class='btn btn-sm btn-info declaration-son-daughter-btn' data-id='${row.registrationNo}'>Download</button>`;
                        },
                    },
                ]
            });
        }
        return () => {
            if (tableRef.current) {
                const table = $(tableRef.current).DataTable();
                if (table) {
                    table.destroy();
                }
                $(tableRef.current).off("change", ".status-dropdown");
                $(tableRef.current).off("change", ".file-input");
                $('#productsTable tbody').off('click', '.download-btn');
                $('#productsTable tbody').off('click', '.download-doc-btn');
                $('#productsTable tbody').off('click', '.upload-btn');
                $('#productsTable tbody').off('click', '.gazette-btn');
                $('#productsTable tbody').off('click', '.declaration-self-btn');
                $('#productsTable tbody').off('click', '.declaration-son-daughter-btn');
            }
        };
    }, [publicationData]);

    const generatePDF = (record, type) => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 14;

        const oldFullName = `${record.oldFirstName || ""} ${record.oldMiddleName || ""} ${record.oldLastName || ""}`.trim() || "-";
        const newFullName = `${record.newFirstName || ""} ${record.newMiddleName || ""} ${record.newLastName || ""}`.trim() || record.name || "-";
        const fullAddress = record.address
            ? `${record.address}, ${record.district || ""}, ${record.pinCode || ""}`
            : "-";

        // ── Header ──────────────────────────────────────────────────────────────
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text("NAME PUBLICATION - SUBMITTED FORM", pageWidth / 2, 18, { align: "center" });

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(`Registration No: ${record.registrationNo || "-"}`, margin, 28);
        doc.text(`Date: ${record.startDate || "-"}`, pageWidth - margin, 28, { align: "right" });

        doc.setLineWidth(0.5);
        doc.line(margin, 32, pageWidth - margin, 32);

        // ── Applicant Details ────────────────────────────────────────────────────
        let y = 40;
        const lineH = 8;
        const col1 = margin;
        const col2 = 75;

        const addRow = (label, value) => {
            doc.setFont("helvetica", "bold");
            doc.text(`${label}:`, col1, y);
            doc.setFont("helvetica", "normal");
            const lines = doc.splitTextToSize(String(value || "-"), pageWidth - col2 - margin);
            doc.text(lines, col2, y);
            y += lineH * lines.length;
        };

        addRow("Applicant Name", record.name);
        addRow("Old Name", oldFullName);
        addRow("New Name", newFullName);
        addRow("Father / Husband Name", record.fatherName || record.husbandName);
        addRow("Reason", record.reason);
        addRow("Address", fullAddress);
        addRow("District", record.district);
        addRow("PIN Code", record.pinCode);
        addRow("Mobile No.", record.mobileNo);
        addRow("Telephone", record.telephone);
        addRow("Status", record.status);
        addRow("Comment", record.comment);

        // ── Footer line ──────────────────────────────────────────────────────────
        y += 4;
        doc.setLineWidth(0.3);
        doc.line(margin, y, pageWidth - margin, y);
        y += 6;
        doc.setFontSize(8);
        doc.setTextColor(120);
        doc.text("Generated by QuickServe", pageWidth / 2, y, { align: "center" });

        doc.save(`NamePublication_Form_${record.registrationNo || "download"}.pdf`);
    };

    const downloadPDF = async (registrationNo, type) => {
        try {
            const authToken = localStorage.getItem("authToken");
            const endpoint = type === "form"
                ? `${API_BASE_URL}/NamePublication/DownloadPdf/${registrationNo}`
                : `${API_BASE_URL}/NamePublication/DownloadDocument/${registrationNo}`;

            const response = await fetch(endpoint, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to download file: ${response.status}`);
            }

            if (type === "form" || type === "gazette" || type === "declaration-self" || type === "declaration-son-daughter") {
                // ✅ API returns JSON (data for form)
                const record = await response.json();
                console.log("📌 Name Publication API Data:", record);
                generatePDF(record, type);
            } else {
                // ✅ For documents, API returns blob
                const blob = await response.blob();
                const contentType = response.headers.get("Content-Type");

                // Determine file extension from MIME type
                const fileExtension = contentType.split("/")[1] || "pdf";

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `NamePublication_${type}_${registrationNo}.${fileExtension}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error("Download error:", error);
        }
    };

    // File Upload Function
    const uploadFile = async (registrationNo, file) => {
        console.log("File selected:", file.name);  // Log the file name here
        try {
            const authToken = localStorage.getItem("authToken");
            const formData = new FormData();
            formData.append("file", file);

            // ✅ Use backticks (`) for the correct API URL format
            const response = await fetch(`${API_BASE_URL}/NamePublication/upload-receipt/${registrationNo}`, {
                method: "POST",
                headers: { Authorization: `Bearer ${authToken}` }, // No 'Content-Type' for FormData
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Failed to upload file: ${response.status}`);
            }

            const data = await response.json();
            alert("✅ File uploaded successfully!");

            // ✅ Update the data state with the correct file path          

            setPublicationData((prevData) =>
                prevData.map((item) =>
                    item.registrationNo === registrationNo
                        ? { ...item, PanReceiptPath: data.FilePath } // Use consistent casing
                        : item
                )
            );


            // ✅ Force DataTable to redraw
            const table = $('#productsTable').DataTable();
            table.clear();
            table.rows.add(publicationData); // Update the table with the new data
            table.draw();

        } catch (error) {
            console.error("Upload error:", error);
            alert("❌ Failed to upload file.");
        }
    };

    return (

        <table
            ref={tableRef}
            id="productsTable"
            className="table table-bordered table-hover table-product"
            style={{ width: '100%' }}
        >
            <thead>
                <tr>
                    <th>Sr. No.</th>
                    <th>Date</th>
                    <th>Applicant Name</th>
                    <th>New Name</th>
                    <th>Registration No</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Submitted Form</th>
                    <th>Document</th>
                    <th>Upload Receipt</th>
                    <th>Gazette Form</th>
                    <th>DECLARATION - SELF</th>
                    <th>DECLARATION - SON & DAUGHTER</th>
                </tr>
            </thead>
        </table>

    );
};

export default NamePublicationAdminReport;